import { render, staticRenderFns } from "./area51.vue?vue&type=template&id=6358c1de"
import script from "./area51.vue?vue&type=script&lang=js"
export * from "./area51.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../sa-platform-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports